export default __webpack_public_path__ + "static/1219-fc741361b81a99f0b8eb42709aee83e9.gif";